import { get, keyBy, isEmpty } from 'lodash'
import { FETCH_VENUES_SUCCEEDED, SELECT_VENUE } from './constants'
import { SIGN_OUT } from '../AppState/constants'


const initialState = {
  byId: {},
  selectedId: '',
}

export default (state = initialState, { type, payload }) => {
  switch (type) {

    case FETCH_VENUES_SUCCEEDED: {
      const venues = payload.venues.map(({ venueName, venueUuid, timeZone }) => ({
        timeZone,
        label: venueName,
        value: venueUuid,
      }))

      const isSelectedIdInPayload = venues.some(venue => venue.value === state.selectedId)

      return {
        ...state,
        byId: keyBy(venues, 'value'),
        selectedId:
          isEmpty(state.selectedId) || !isSelectedIdInPayload
            ? get(venues, [0, 'value'])
            : state.selectedId,
      }
    }

    case SIGN_OUT: {
      return {
        ...state,
        selectedId: '',
      }
    }

    case SELECT_VENUE: {
      return {
        ...state,
        selectedId: payload,
      }
    }

    default:
      return state
  }
}
